export default __webpack_public_path__ + "static/media/curved6.a3404381.jpg";